function injectStyle (ssrContext) {
  require("!!../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-23e3b813\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Text.vue")
}
var Component = require("!../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Text.vue"),
  /* template */
  require("!!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-23e3b813\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Text.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23e3b813",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/views/certificate/components/data/components/text/Text.vue
// module id = b154071aa5efb6369095
// module chunks = 9